import React, { useState, useEffect } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Weather = ({ handleWeatherClick, lang, items, season, weather }) => {
	const [hasFoggyItems, setHasFoggyItems] = useState(false);
	const [hasSunnyItems, setHasSunnyItems] = useState(false);
	const [hasCloudyItems, setHasCloudyItems] = useState(false);
	const [hasChangeableItems, setHasChangeableItems] = useState(false);

	useEffect(() => {
		setHasSunnyItems(false);
		setHasChangeableItems(false);
		setHasCloudyItems(false);
		setHasFoggyItems(false);

		if (items?.length > 0) {
			items.map(item => {
				if (item?.keywords) {
					if (
						item.keywords.some(keyword => keyword.title === "Sonnig") &&
						item.keywords.some(keyword => keyword.title === season)
					) {
						setHasSunnyItems(true);
					}
					if (
						item.keywords.some(keyword => keyword.title === "Nebelig") &&
						item.keywords.some(keyword => keyword.title === season)
					) {
						setHasFoggyItems(true);
					}
					if (
						item.keywords.some(keyword => keyword.title === "Bewölkt") &&
						item.keywords.some(keyword => keyword.title === season)
					) {
						setHasCloudyItems(true);
					}
					if (
						item.keywords.some(keyword => keyword.title === "Wechselhaft") &&
						item.keywords.some(keyword => keyword.title === season)
					) {
						setHasChangeableItems(true);
					}
				}
				return null;
			});
		}
	}, [items, season]);

	return (
		<div className={clsx("video-player-root__buttons", "video-player-root__buttons--weather")}>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": weather === "Nebelig",
					"video-player-root__buttons-button--disabled": !hasFoggyItems
				})}
				onClick={event => handleWeatherClick(event, "Nebelig")}
				title="Nebelig"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/foggy.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": weather === "Sonnig",
					"video-player-root__buttons-button--disabled": !hasSunnyItems
				})}
				onClick={event => handleWeatherClick(event, "Sonnig")}
				title="Sonnig"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/sunny.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": weather === "Bewölkt",
					"video-player-root__buttons-button--disabled": !hasCloudyItems
				})}
				onClick={event => handleWeatherClick(event, "Bewölkt")}
				title="Bewölkt"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/cloudy.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": weather === "Wechselhaft",
					"video-player-root__buttons-button--disabled": !hasChangeableItems
				})}
				onClick={event => handleWeatherClick(event, "Wechselhaft")}
				title="Wechselhaft"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/changeable.svg" size={24} />
			</div>
			<span className={clsx("video-player-root__buttons-label")}>
				{lang === "de" ? "Wetter" : "Weather"}
			</span>
		</div>
	);
};

export default Weather;
